module.exports = __webpack_public_path__ + "img/leftImage.b4b403d5.png";